import { AIRPORT, AIRPORT_AND_STATION, TRAIN_STATION } from 'constants/seo';

import type { InternalLink } from 'HotelList-Types';

const filterInternalLinks = (data: Array<InternalLink>) => {
  if (data?.length > 0) {
    const local = [AIRPORT, TRAIN_STATION];
    let mergedArray = [] as Array<InternalLink>;
    const newObj = { type: AIRPORT_AND_STATION } as InternalLink;
    for (const eachObj of data) {
      if (local.includes(eachObj?.type)) {
        newObj.places = newObj?.places ? [...newObj.places, ...eachObj.places] : eachObj.places;
        newObj.type = AIRPORT_AND_STATION;
      } else {
        mergedArray.push(eachObj);
      }
    }
    if (newObj?.places) {
      mergedArray = [newObj, ...mergedArray];
    }
    return mergedArray;
  }
  return [];
};

export { filterInternalLinks };
